module.exports = __webpack_public_path__ + "static/media/CircleOn.c85085b9.svg";